module.exports = __webpack_public_path__ + "img/standard.09e3a470.svg";